import { useCallback } from 'react';

import { useAudioTrigger } from '@pp/core/src/controllers/audioController/hooks';
import { betActions } from '@pp/core/src/store/slices/bets/slice';
import { useConfigSlice } from '@pp/core/src/store/slices/config/selectors';
import { useGameStateSlice } from '@pp/core/src/store/slices/game/selectors';

import { Bets } from '../../../config/bets';
import { GameCommunicationBetSender } from '../../../controllers/gameCommunication/senders';
import { GameStore, useGameDispatch } from '../../../store/GameStore';
import { crashAutoplayActions } from '../../../store/slices/crashAutoplay/slice';
import { useHighflyerStateSlice } from '../../../store/slices/highflyerState/selectors';
import { highflyerStateActions } from '../../../store/slices/highflyerState/slice';

const sender = new GameCommunicationBetSender();

export const useOnCancelCallbackConnected = (betId: Bets): ((a: Bets) => void) => {
  const dispatch = useGameDispatch();
  const isBetsOpen = useGameStateSlice.isBetsOpenStatus();
  const isFullCashed = useHighflyerStateSlice.isFullCashed();
  const isInfiniteAutoPlayEnabled = useConfigSlice.isInfiniteAutoPlayEnabled();
  const audioTrigger = useAudioTrigger();
  const isDealingInProgress = useHighflyerStateSlice.isDealingInProgress(betId);
  return useCallback(
    (betCode: Bets) => {
      const autoPlayInProgress = GameStore.getState().crashAutoplay.isInProgress;
      const isEnable = GameStore.getState().crashAutoplay.isEnabled;
      if (isInfiniteAutoPlayEnabled && autoPlayInProgress[betCode] && isEnable[betCode]) {
        dispatch(crashAutoplayActions.setInfiniteAutoplayEnabledOnCalncel({ bestSpot: betCode, cancelled: false }));
      }

      if (isBetsOpen) {
        dispatch(betActions.clearBet(betCode));
        sender.dispatch('');
      } else {
        dispatch(highflyerStateActions.setEarlyBetAmount({ betCode: betCode, amount: 0 }));
        dispatch(crashAutoplayActions.setIsCancelled({ bestSpot: betCode, cancelled: true }));
        if (isFullCashed) {
          dispatch(betActions.clearBet(betCode));
        }
      }

      if (!isDealingInProgress) dispatch(highflyerStateActions.resetIsBetPlaced(betCode));
      audioTrigger.play({ name: 'undoClick' });
    },
    [isInfiniteAutoPlayEnabled, isBetsOpen, audioTrigger, dispatch, isFullCashed, isDealingInProgress]
  );
};
